<mat-card appearance="outlined" class="mat-elevation-z1 mat-card-scrollable">
    <ng-container>
        <mat-card-header>
            <mat-card-title>{{ 'AgendaItems.Title' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content class="container">
            <div class="row no-gutters sl-header agenda-items-header">
                <div class="col col-md-1">{{ 'General.NumberAbbr' | translate }}</div>
                <div class="col col-md-6">{{ 'General.Title' | translate }}</div>
                <div class="col col-md-1">{{ 'AgendaItems.Start' | translate }}</div>
                <div class="col col-md-1">{{ 'AgendaItems.End' | translate }}</div>
                <div class="col col-md-3"></div>
            </div>
            @for (item of agendaItems(); track item.number + item.description) {
                <div
                    class="sl-agenda-items-row row align-items-center no-gutters agenda-item"
                    (click)="item.showResults = !item.showResults"
                    [class.expanded]="item.showResults"
                    [class.child]="!!item.parentGmAgendaItemNumber"
                    [class.voting-running]="!item.hasChildren && !!item.votingStartedDateTime && !item.resultAcceptedTime"
                    [class.voting-running]="
                        item.hasChildren && item.childrenNotStarted.length === 0 && item.childrenVoteAccepted.length === 0
                    "
                    [class.voting-finished]="!item.hasChildren && !!item.resultAcceptedTime"
                    [class.voting-finished]="item.hasChildren && item.childrenVoteAccepted.length === item.childrenCount">
                    @if (item.number !== '1' && !item.parentGmAgendaItemNumber) {
                        <mat-divider />
                    }
                    <div class="col col-md-1">
                        <div class="sl-agenda-number">{{ item.number }}</div>
                    </div>
                    <div class="col col-md-6 sl-description">{{ item.description }}</div>
                    <div class="col col-md-1 sl-start-date">
                        {{ item.votingStartedDateTime | localizedDate: 'shortTime' }}
                    </div>
                    <div class="col col-md-1 sl-end-date">{{ item.votingEndedDateTime | localizedDate: 'shortTime' }}</div>
                    <div
                        class="col col-md-3 sl-agenda-controls"
                        [class.sl-child-agenda-controls]="!!item.parentGmAgendaItemNumber"
                        (click)="$event.stopPropagation()">
                        <button
                            mat-icon-button
                            (click)="startVote(item.gmAgendaItemNumber)"
                            class="sl-button"
                            matTooltip="{{ 'GeneralMeeting.StartVoting' | translate }}"
                            [disabled]="
                                gmAgendaItemNumberStartingVote() !== undefined
                                || (!item.hasChildren && !!item.votingStartedDateTime)
                                || (item.hasChildren && item.childrenNotStarted.length === 0)
                            ">
                            @if (gmAgendaItemNumberStartingVote() === item.gmAgendaItemNumber) {
                                <mat-spinner diameter="24" />
                            } @else {
                                <mat-icon [class.sl-child-btn]="!!item.parentGmAgendaItemNumber" aria-label="Start">play_arrow</mat-icon>
                            }
                        </button>
                        <button
                            mat-icon-button
                            (click)="closeVote(item.gmAgendaItemNumber)"
                            class="sl-button"
                            matTooltip="{{ 'GeneralMeeting.StopVoting' | translate }}"
                            [disabled]="
                                gmAgendaItemNumberClosingVote() !== undefined
                                || (!item.hasChildren && (!item.votingStartedDateTime || !!item.votingEndedDateTime))
                                || (item.hasChildren && item.childrenVoteOpen.length === 0)
                            ">
                            @if (gmAgendaItemNumberClosingVote() === item.gmAgendaItemNumber) {
                                <mat-spinner diameter="24" />
                            } @else {
                                <mat-icon [class.sl-child-btn]="!!item.parentGmAgendaItemNumber" aria-label="Stop">stop</mat-icon>
                            }
                        </button>
                        @if (
                            (!!item.votingEndedDateTime && !item.hasChildren && !item.resultAcceptedTime)
                            || (item.hasChildren
                                && item.childrenVoteFinished.length === item.childrenCount
                                && item.childrenVoteAccepted.length === 0)
                        ) {
                            <button
                                mat-icon-button
                                [matTooltip]="'GeneralMeeting.AcceptResults' | translate"
                                class="sl-button"
                                (click)="accept(item.gmAgendaItemNumber)">
                                <mat-icon>check</mat-icon>
                            </button>
                        } @else if (
                            (!!item.votingEndedDateTime && !item.hasChildren && !!item.resultAcceptedTime)
                            || (item.hasChildren
                                && item.childrenVoteFinished.length === item.childrenCount
                                && item.childrenVoteAccepted.length === item.childrenCount)
                        ) {
                            <button
                                mat-icon-button
                                [matTooltip]="'GeneralMeeting.UndoAcceptResults' | translate"
                                class="sl-button accepted"
                                (click)="undoAccept(item.gmAgendaItemNumber)">
                                <mat-icon>check</mat-icon>
                            </button>
                        } @else {
                            <button mat-icon-button class="sl-button" disabled>
                                <mat-icon>check</mat-icon>
                            </button>
                        }
                        <button mat-icon-button [matMenuTriggerFor]="menu" class="sl-button">
                            <mat-icon aria-label="Reset">more_vert</mat-icon>
                        </button>
                        <mat-menu #menu>
                            <button
                                mat-menu-item
                                (click)="deleteVote(item.gmAgendaItemNumber)"
                                [disabled]="
                                    (!item.hasChildren && !item.votingEndedDateTime)
                                    || (item.hasChildren && item.childrenVoteFinished.length === 0)
                                ">
                                {{ 'GeneralMeeting.ResetVoting' | translate }}
                            </button>
                            <button
                                mat-menu-item
                                (click)="openImportVotesDialog(item)"
                                [disabled]="
                                    (!item.hasChildren && !!item.votingEndedDateTime)
                                    || (item.hasChildren && item.childrenVoteOpen.length === 0)
                                ">
                                {{ 'GeneralMeeting.ImportVotes' | translate }}
                            </button>
                            <button mat-menu-item (click)="viewSettings(item.gmAgendaItemNumber)">
                                {{ 'MenuItem.Settings' | translate }}
                            </button>
                            <button mat-menu-item (click)="duplicateAgendaItem(item.gmAgendaItemNumber)">
                                {{ 'GeneralMeeting.DuplicateAgendaItem' | translate }}
                            </button>
                            <button mat-menu-item (click)="deleteAgendaItem(item.gmAgendaItemNumber)">
                                {{ 'GeneralMeeting.DeleteAgendaItem' | translate }}
                            </button>
                        </mat-menu>
                    </div>
                    <div class="voting-results">
                        <div class="col col-7 offset-1">
                            @if (!!item.votingEndedDateTime) {
                                <sl-voting-results [agendaItem]="item" />
                            }
                        </div>
                    </div>
                </div>
            }
        </mat-card-content>
    </ng-container>
</mat-card>
